function DataTable({
    className,
    headerClassName,
    rowClassName,
    columns,
    rows,
    getRowKey,
    onRowClick
}) {
    const resolveRowClassName = (row) => {
        if (typeof rowClassName === 'function') {
            return rowClassName(row);
        }
        return rowClassName || '';
    };

    return (
        <div className={className}>
            <div className={headerClassName}>
                {columns.map((column) => (
                    <span key={column.key}>{column.label}</span>
                ))}
            </div>
            {rows.map((row, index) => {
                const key = getRowKey ? getRowKey(row, index) : index;
                const clickable = typeof onRowClick === 'function';

                return (
                    <div
                        key={key}
                        className={resolveRowClassName(row)}
                        role={clickable ? 'button' : undefined}
                        tabIndex={clickable ? 0 : undefined}
                        onClick={clickable ? () => onRowClick(row) : undefined}
                        onKeyDown={clickable ? (event) => {
                            if (event.key === 'Enter') {
                                onRowClick(row);
                            }
                        } : undefined}
                    >
                        {columns.map((column) => (
                            <span key={column.key}>
                                {column.render ? column.render(row) : row[column.key]}
                            </span>
                        ))}
                    </div>
                );
            })}
        </div>
    );
}

export default DataTable;
